var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxtFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1789 15.797H3.26834V17.4312H2.1789C0.953267 17.4312 0 16.4779 0 15.2523V2.1789C0 0.987312 0.953267 0 2.1789 0H7.79636C8.37513 0 8.91986 0.238317 9.3284 0.64686L12.4265 3.74498C12.8351 4.15352 13.0734 4.69825 13.0734 5.27701V9.80503H11.4392V5.44724H8.71559C8.10277 5.44724 7.62614 4.97061 7.62614 4.35779V1.63417H2.1789C1.87249 1.63417 1.63417 1.90653 1.63417 2.1789V15.2523C1.63417 15.5587 1.87249 15.797 2.1789 15.797Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4202 12.7642V18.2719H15.1227V12.7642H16.4202ZM17.7555 12.7642V13.7893H13.8252V12.7642H17.7555Z",
    fill: "#98A2B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8405 12.7642L11.4609 14.595L12.0737 12.7642H13.5452L12.3158 15.4953L13.5755 18.2719H12.0888L11.4609 16.407L10.8292 18.2719H9.33496L10.6022 15.4953L9.36522 12.7642H10.8405Z",
    fill: "#98A2B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75711 12.7642V18.2719H6.45961V12.7642H7.75711ZM9.09245 12.7642V13.7893H5.16211V12.7642H9.09245Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtFile);
export default __webpack_public_path__ + "static/media/txt-file.34deffad75c9fa0d86067f637d0ce7b8.svg";
export { ForwardRef as ReactComponent };